import {
    LegacyFilmPlayerBaseInfoContent,
    LegacyVideoPlayerBaseInfoContent,
} from '@funtech-int/kp-graphql-sdk/yango-movies-www';

export function getFilmOtt(
    filmOrVideo:
        | LegacyFilmPlayerBaseInfoContent
        | LegacyVideoPlayerBaseInfoContent
        | undefined
        | null
) {
    if (
        (filmOrVideo?.__typename === 'Film' || filmOrVideo?.__typename === 'Video') &&
        filmOrVideo.filmOtt?.__typename === 'Ott_AbstractVideo'
    ) {
        return filmOrVideo.filmOtt;
    }
}
